import { HomeOutlined, LogoutOutlined, MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { clearUserInfo, setLoginState } from '../store/modules/userStore'
import { useNavigate } from 'react-router-dom';
import { getUserInfo } from '../utils/localStorage/userInfo';
import BreadcrumbNav from './BreadcrumbNav';
import { logoutAPI } from '../apis/user';
import baseRouter from '../router'


const HeaderBar = ({ collapsed, setCollapsed }) => {
    // 获取用户信息：用户名等
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const userInfo = getUserInfo()

    const onConfirm = async () => {
        console.log('用户退出登录')
        await logoutAPI();
        dispatch(setLoginState(false))  //修改登录状态
        dispatch(clearUserInfo())         //清除token等信息
        navigate('/login')
    }
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
            <div className={collapsed ? 'mini-logo' : 'large-logo'} />
            <span className='home-logo'>
                {/* <HomeOutlined /> */}
                <Button
                    type="default"
                    onClick={toggleCollapsed}
                    style={{
                        marginBottom: 16,
                    }}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </Button>
                {/* <BreadcrumbNav routes={baseRouter.routes}/> */}
            </span>
            <div className='user-info' style={{ display: 'flex', alignItems: 'center' }}>
                <span className='user-avatar'><span><img alt='用户头像' src={userInfo.profilePhotoUrl} style={{ width: "45px", height: "45px", borderRadius: "50%" }}></img></span></span>
                <span className='user-name' style={{ fontSize: '17px' }}>{userInfo.managerName}</span>
                <span className='user-logout'>
                    <Popconfirm title='是否确认退出？' okText='退出' cancelText='取消' onConfirm={onConfirm}>
                        <LogoutOutlined /> 退出
                    </Popconfirm>
                </span>
            </div>
        </div>
    )
}
export default HeaderBar
